import { Route } from "@angular/router";

/**
 * Child routes for the FeeCalculator port feature area (B3 slice).
 *
 * Loaded lazily under the `/fee-calculator` parent path declared in
 * `app.routes.ts`. Every route uses `loadComponent` per
 * `.claude/rules/angular-routing.md`.
 */
export const feeCalculatorRoutes: Route[] = [
  { path: "", redirectTo: "fees", pathMatch: "full" },
  {
    path: "fees",
    loadComponent: () =>
      import("./fees/fee-list/fee-list.component").then(
        (m) => m.FeeListComponent,
      ),
    data: { title: "Fee Calculator — Fees" },
  },
  {
    path: "fees/:id",
    loadComponent: () =>
      import("./fees/fee-workspace/fee-workspace.component").then(
        (m) => m.FeeWorkspaceComponent,
      ),
    data: { title: "Fee Calculator — Fee Workspace" },
  },
  {
    path: "exemptions",
    loadComponent: () =>
      import("./exemptions/exemption-list/exemption-list.component").then(
        (m) => m.ExemptionListComponent,
      ),
    data: { title: "Fee Calculator — Exemptions" },
  },
  {
    path: "exemptions/:id",
    loadComponent: () =>
      import("./exemptions/exemption-detail/exemption-detail.component").then(
        (m) => m.ExemptionDetailComponent,
      ),
    data: { title: "Fee Calculator — Exemption Detail" },
  },
  {
    path: "questions",
    loadComponent: () =>
      import("./questions/question-list/question-list.component").then(
        (m) => m.QuestionListComponent,
      ),
    data: { title: "Fee Calculator — Questions" },
  },
  {
    path: "properties",
    loadComponent: () =>
      import("./properties/property-list/property-list.component").then(
        (m) => m.PropertyListComponent,
      ),
    data: { title: "Fee Calculator — Properties" },
  },
  {
    path: "data-sources",
    loadComponent: () =>
      import("./data-sources/data-source-list/data-source-list.component").then(
        (m) => m.DataSourceListComponent,
      ),
    data: { title: "Fee Calculator — Data Sources" },
  },
  {
    path: "calculator",
    loadComponent: () =>
      import("./calculator/calculator.component").then(
        (m) => m.CalculatorComponent,
      ),
    data: { title: "Fee Calculator — Calculator" },
  },
];
